export const camelToSentenceCase = (text: string) => {
  const result = text
    .replace(/([A-Z])/g, " $1")
    .replace(/(?<=[A-Z]) ([A-Z])(?= )/g, "$1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};
